RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const VIDEO_RETENTION_GRAPH_HEIGHT = 208;

    const VideoMetricView = RivalIQ.apps.Dashboard.widgets.MetricLegendView.extend({
        loadData: function () {
            const me = this;

            const optionalMetrics = ['submetric', 'submetricFilter'];
            const metricDefinition = me.dashboardModel.metric;

            const metrics = _.compact([metricDefinition].concat(
                _.map(optionalMetrics, function (optionalMetric) {
                    return me.dashboardModel[optionalMetric];
                })
            ));

            const collection = new RivalIQ.collections.MetricDefinitions(metrics);

            return collection.fetch()
                .done(function (collection) {
                    me.model = collection.first();
                    let metricIdx = 1;

                    _.forEach(optionalMetrics, function (optionalMetric) {
                        if (me.dashboardModel[optionalMetric]) {
                            me[optionalMetric] = collection.at(metricIdx++);
                        }
                    });
                });
        },

        serializeData: function () {
            const me = this;

            const data = RivalIQ.apps.Dashboard.widgets.MetricLegendView.prototype.serializeData.apply(me, arguments);

            if (me.submetricFilter) {
                const filter = me.submetricFilter.getValue({
                    format: false
                });
                if (!filter) {
                    data.submetric = null;

                    if (me.dashboardModel.submetricFallback) {
                        data.submetric = me.dashboardModel.submetricFallback;
                    }
                }
            }

            return data;
        }
    });
    const VideoMetricWidget = RivalIQ.apps.Dashboard.widgets.MetricWidget.extend({
        scheduledExportAdvancedSettingsEnabled: false,
        view: VideoMetricView
    });
    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_VIDEO_VIEWS, VideoMetricWidget);

    const FbPostDetailsVideoDetailsView = RivalIQ.apps.Dashboard.views.Layout.mixin({
        childView: Marionette.Dashboard.views.Widgets,

        initialize: function () {
            const me = this;

            RivalIQ.apps.Dashboard.views.Layout.prototype.initialize.apply(me, arguments);
            me.collection = me.dashboardModel.getWidgets();
        },

        template: '#insightsVerticalTemplate',

        sectionClassName: 'widgets-region panel-body',

        config: [
            [
                {
                    name: 'left-top',
                    sizes: {
                        sm: '3'
                    }
                },
                {
                    name: 'top-right1',
                    sizes: {
                        sm: '3'
                    }
                },
                {
                    name: 'top-right2',
                    sizes: {
                        sm: '3'
                    }
                },
                {
                    name: 'top-right3',
                    sizes: {
                        sm: '3'
                    }
                },
                {
                    name: 'left',
                    sizes: {
                        sm: '6'
                    },
                    className: 'stacked'
                },
                {
                    name: 'right',
                    sizes: {
                        sm: '6'
                    }
                }
            ]
        ]
    });

    const FbPostDetailsVideoDetailsWidget = widgets.PostDetailsWidgetBase.extend({
        title: RivalIQ.strings.facebook_insights_post_detail_video_details_title,
        description: RivalIQ.strings.facebook_insights_post_detail_video_details_description,
        view: FbPostDetailsVideoDetailsView,
        viewMore: false,
        propsToSerializeForExport: [],
        processProps: function (props) {
            const me = this;

            if (!me.metric) {
                me.metric = new RivalIQ.models.MetricDefinition({
                    concept: RivalIQ.metrics.id.FACEBOOK_INSIGHTS_POST_DETAILS,
                    companyId: props.companyId,
                    channel: props.channel,
                    objectType: props.objectType,
                    postId: props.postId
                });
            }

            _.extend(me.metric.attributes, _.pick(props, 'companyId', 'channel', 'objectType', 'postId'));

            return props;
        },

        widgetDefinitions: function () {
            const me = this;
            const metric = me.metric;

            return [
                {
                    widgetId: RivalIQ.enums.widgetTypes.FB_INSIGHTS_VIDEO_VIEWS,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_VIEWS', {
                        default: 0,
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_ORGANIC_VIDEO_VIEWS',
                            'FACEBOOK_INSIGHTS_POST_PAID_VIDEO_VIEWS'
                        ]
                    }),
                    submetric: metric.create('FACEBOOK_INSIGHTS_POST_LIVE_VIDEO_VIEWS'),
                    submetricFilter: metric.create('FACEBOOK_INSIGHTS_POST_WAS_LIVE_VIDEO'),
                    submetricFallback: {
                        name: RivalIQ.strings.facebook_insights_post_detail_percent_viewers_title,
                        value: '100%'
                    },
                    region: 'left-top'
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_LEGEND,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_10_SECOND_VIEWS', {
                        default: 0,
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_ORGANIC_VIDEO_10_SECOND_VIEWS',
                            'FACEBOOK_INSIGHTS_POST_PAID_VIDEO_10_SECOND_VIEWS'
                        ]
                    }),
                    submetric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_10_SECOND_VIEWS_PERCENT', {
                        name: RivalIQ.strings.facebook_insights_post_detail_percent_viewers_title
                    }),
                    region: 'top-right1'
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_LEGEND,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_30_SECOND_VIEWS', {
                        default: 0,
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_ORGANIC_VIDEO_30_SECOND_VIEWS',
                            'FACEBOOK_INSIGHTS_POST_PAID_VIDEO_30_SECOND_VIEWS'
                        ]
                    }),
                    submetric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_30_SECOND_VIEWS_PERCENT', {
                        name: RivalIQ.strings.facebook_insights_post_detail_percent_viewers_title
                    }),
                    region: 'top-right2'
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_LEGEND,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_95_PERCENT_VIEWS', {
                        default: 0,
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_ORGANIC_VIDEO_95_PERCENT_VIEWS',
                            'FACEBOOK_INSIGHTS_POST_PAID_VIDEO_95_PERCENT_VIEWS'
                        ]
                    }),
                    submetric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_95_PERCENT_VIEW_RATE', {
                        name: RivalIQ.strings.facebook_insights_post_detail_percent_viewers_title
                    }),
                    region: 'top-right3'
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_BAR_CHART_BREAKOUT,
                    hideMetric: true,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_VIEWS', {
                        name: RivalIQ.strings.facebook_insights_post_detail_video_details_auto_vs_click_title,
                        description: RivalIQ.strings.facebook_insights_post_detail_video_details_auto_vs_click_info
                    }),
                    chart: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_AUTO_PLAY_VIDEO_PLAYS',
                            'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_CLICK_TO_PLAY_VIDEO_PLAYS'
                        ]
                    }),
                    region: 'left'
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_BAR_CHART_BREAKOUT,
                    hideMetric: true,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_VIEWS', {
                        name: RivalIQ.strings.facebook_insights_post_detail_video_details_sound_on_vs_off_title,
                        description: RivalIQ.strings.facebook_insights_post_detail_video_details_sound_on_vs_off_info
                    }),
                    chart: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_SOUND_OFF_VIDEO_PLAYS',
                            'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_SOUND_ON_VIDEO_PLAYS'
                        ]
                    }),
                    region: 'left'
                },
                {
                    instanceId: 'video-retention-graph',
                    widgetId: RivalIQ.enums.widgetTypes.FB_INSIGHTS_VIDEO_RETENTION_CHART,
                    className: 'panel-list-item',
                    title: RivalIQ.strings.facebook_insights_post_detail_video_details_retention_title,

                    props: {
                        height: VIDEO_RETENTION_GRAPH_HEIGHT,
                        metric: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                            className: 'link-clicks',
                            dimensions: ['post_video_retention_graph'],
                            property: 'pct_viewers',
                            type: RivalIQ.metrics.dataType.NUMERIC,

                            name: RivalIQ.strings.facebook_insights_post_detail_video_details_retention_information_title,
                            description: RivalIQ.strings.facebook_insights_post_detail_video_details_retention_info,

                            domainFormat: function (value, metric) {

                                const path = [
                                    'dimensions',
                                    metric.get('dimensions')[0],
                                    'buckets',
                                    value,
                                    'video_time_millis'
                                ];

                                return RivalIQ.formatter.formatTimeInterval(_.get(metric.data, path));
                            }
                        })
                    },
                    region: 'right'
                }
            ];
        },
        filter: function () {
            const me = this;
            return !me.curation.isFbVideo;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_POST_VIDEO_DETAILS, FbPostDetailsVideoDetailsWidget);


    const RetentionChart = RivalIQ.apps.Dashboard.widgets.LineChart.extend({

        ui: {
            noDataMessage: '.no-retention-data-msg'
        },

        template: '#videoRetentionChartTemplate',

        behaviors: function () {
            const me = this;

            const metric = me.dashboardModel.metric || me.dashboardModel.metrics[0];
            const information = metric.getInformation();

            return {
                Titles: RivalIQ.behaviors.Titles,
                Information: {
                    behaviorClass: RivalIQ.behaviors.Information,
                    information: information
                }
            };
        },

        loadData: function () {
            const me = this;

            // NOTE: I do this as the line chart widget we extend from is based on multiple lines, but this graph is only used for one metric.
            const metricDefinitions = new RivalIQ.collections.MetricDefinitions([me.dashboardModel.metric]);

            return metricDefinitions.fetch()
                .done(function (metrics) {
                    me.model = metrics.at(0);
                    me.collection = metrics;
                });
        },

        showChart: function () {
            const me = this;

            const hasData = !_.isEmpty(me.model.getChartData());
            if (hasData) {
                me.ui.noDataMessage.hide();
                return RivalIQ.apps.Dashboard.widgets.LineChart.prototype.showChart.call(me);
            } else {
                me.ui.noDataMessage.show();
            }
        },

        getChartAttributes: function () {
            const me = this;

            let attrs = RivalIQ.apps.Dashboard.widgets.LineChart.prototype.getChartAttributes.apply(me, arguments);

            attrs = _.extend(attrs, {
                yMax: 1.0
            });

            return attrs;
        },


        serializeData: function () {

            const me = this;
            return {
                title: me.dashboardModel.getTitle()
            };
        }
    });

    const RetentionWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: RetentionChart,
        scheduledExportAdvancedSettingsEnabled: false,

        processProps: function (props) {
            const me = this;

            me.metric = props.metric;

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_VIDEO_RETENTION_CHART, RetentionWidget);
});
